import { historyAttachments } from './agent-asset.mjs'
import { normalizeStructuredData } from './agent-chat-event-adapter.mjs'

export function selectAgentTransport({
  runtimeEngine = 'legacy',
  conversationRoute = null,
  useWsAgentChat = false,
} = {}) {
  if (runtimeEngine !== 'mastra') return useWsAgentChat ? 'legacy-ws' : 'legacy-sse'
  if (!conversationRoute?.transport) throw new Error('mastra_route_missing')
  if (conversationRoute.transport !== 'ndjson') throw new Error('mastra_transport_unsupported')
  return 'mastra-ndjson'
}

export function routeNeedsRefresh(conversationRoute, nowMs = Date.now(), skewSeconds = 30) {
  if (!conversationRoute?.chatTicket || !conversationRoute?.endpoint) return true
  const expiresAt = Number(conversationRoute.expiresAt || 0)
  if (!Number.isFinite(expiresAt) || expiresAt <= 0) return true
  return expiresAt * 1000 <= nowMs + skewSeconds * 1000
}

export function resolveArtifactEntryMode(runtimeEngine) {
  // Readiness controls which tools the model receives, not where existing tasks appear.
  return runtimeEngine === 'mastra' ? 'chat' : 'manual'
}

export function normalizeHistoryMessages(list) {
  if (!Array.isArray(list)) return []
  return list.map(message => ({
    role: message.chatRole,
    content: message.chatContent || '',
    msgId: message.msgId || message.guid || '',
    guid: message.guid || message.msgId || '',
    timestamp: message.createTime,
    createTimeText: message.createTimeText,
    isLoading: false,
    starting: false,
    finished: true,
    type: message.contentType || 'text',
    isCollected: Boolean(message.isCollected),
    messageType: message.messageType,
    messageIndex: message.messageIndex,
    structuredData: message.structuredData
      ? normalizeStructuredData(message.structuredData)
      : null,
    contentParts: Array.isArray(message.contentParts) ? message.contentParts : [],
    messageStatus: message.messageStatus || 'completed',
    incomplete: Boolean(message.incomplete),
    executionId: message.executionId || '',
    imgUrls: Array.isArray(message.imgUrls) ? message.imgUrls : [],
    fileUrls: Array.isArray(message.fileUrls) ? message.fileUrls : [],
    attachments: historyAttachments(message),
  })).reverse()
}

/** Insert one newest-first server page before current messages without losing in-flight local replies. */
export function mergeHistoryPage(currentMessages, newestFirstPage) {
  const current = Array.isArray(currentMessages) ? currentMessages : []
  const knownIds = new Set(current.map(message => message.msgId).filter(Boolean))
  const page = normalizeHistoryMessages(newestFirstPage)
  const unseen = page.filter(message => {
    if (!message.msgId || knownIds.has(message.msgId)) return false
    knownIds.add(message.msgId)
    return true
  })
  return [...unseen, ...current]
}

/** Ignore history from a session or request generation that is no longer active. */
export function shouldApplyHistoryResponse(requestSessionGuid, requestVersion, activeSessionGuid, activeVersion) {
  return Boolean(requestSessionGuid) && requestSessionGuid === activeSessionGuid && requestVersion === activeVersion
}

export function lastConfirmedMessageId(messages) {
  if (!Array.isArray(messages)) return ''
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    if (messages[index]?.msgId) return messages[index].msgId
  }
  return ''
}
